const locale = {
   "Welcome":{
      "header":"Bienvenue à RABAT App",
      "p1":"Le RABAT de l'Application est un BirdSafe® BRICOLAGE, outil d'évaluation du risque visant à estimer le jour et la nuit collision menaces que d'un bâtiment et de ses façades, pose d'oiseau species.",
      "p2":"A ‘façade’ est toute la face extérieure d'un bâtiment qui peut constituer une menace spécifique d'oiseau collisions.",
      "p3":"To déterminer un bâtiment et de ses façades collision menace cotes, suivez les étapes sous \"Construire Paramètres du Compte\".",
      "p4":"Cette application fournit une évaluation générale d'un bâtiment et de ses façades. RABAT-Canada recommande qu'une évaluation complète soit menée pour l'exactitude. ",
      "vist_birdsafe":"Visiter birdsafe.ca pour une évaluation complète détails",
      "p5":"BirdSafe® de l'évaluation des risques ne serait pas possible sans le généreux d'entrée de l'Amérique du Nord grands experts oiseau bâtiment collisions.",
      "acknowledgements":"Acknowledgements",
      "begin":"Begin l'Évaluation des Risques"
   },
   "Manage":{
      "header":"Les bâtiments Paramètres du Compte",
      "step1":"ÉTAPE 1. Ajouter bâtiment nom et numéro de rue pour être évalué",
      "add":"Ajoutez",
      "delete":"Delete",
      "or":"OU",
      "select_existing_building":"Select bâtiment existant",
      "step2":"ÉTAPE 2. Ajouter toutes les façades devront être évalués",
      "visit_birdsafe":"Visiter birdsafe.ca pour des exemples de façades",
      "select_existing_facade":"Sélectionnez existant façade.",
      "step3":"STEP 3. Évaluer sélectionné pour façade",
      "assess":"Évaluer",
      "optional_track_collision_rates":"FACULTATIF: le Suivi des taux de collisions au niveau de l'individu façades en cours d'évaluation pour",
      "global_mapper":"Global Oiseau Collision Mappeur",
      "enter_building_name":"Veuillez entrer dans l'immeuble name:",
      "confirm_delete_building":"Are -vous sûr de vouloir supprimer ce bâtiment?",
      "building":"Bâtiment",
      "current_building":"édifice actuel",
      "enter_facade_name":"Veuillez entrer Façade name:",
      "confirm_delete_facade":"Are -vous sûr de vouloir supprimer cette Façade?",
      "facade":"Façade",
      "current_facade":"façade actuel"
   },
   "Assess":{
      "header":"Évaluer Sélectionné Façade",
      "currently_assessing":"Vous êtes actuellement en train d'évaluer",
      "facade_for":"façade pour",
      "to_include_image_of":"Pour inclure une image de",
      "take_picture_or_select_image_now":"dans le présent rapport, prendre une photo maintenant ou sélectionnez une image à partir de votre device.",
      "take_a_picture":"Take une Photo",
      "select_an_image":"Sélectionnez une Image",
      "daytime_factors":"Diurne Facteurs: ",
      "observe_factors_in_daylight":"Observer les facteurs suivants lors de la lumière du jour",
      "daytime_prompt":"Pour déterminer une façade de collision de la menace de notation, de répondre à toutes les questions ci-dessous en sélectionnant \" OUI \" ou \"NON\".",
      "yes":"OUI",
      "no":"N",
      "regional_landscape":"Régional Landscape:",
      "google_maps":"Google Cartes",
      "are_features_regional":"effectuez l'une ou plusieurs des opérations suivantes paysage régional fonctionnalités existent à moins de 5 km (3 miles) de la construction?",
      "q01":"Dense, terres à bois, garrigues et/ou meadows.",
      "q02":"Flowing/open de l'eau et/ou les zones humides (par exemple la rivière, marais, lac, etc.).",
      "q03":"Des montagnes, des collines, des ravins et/ou distinctes shoreline.",
      "local_landscape":"Local Landscape:",
      "are_features_local":"Do un ou plusieurs des éléments suivants paysage local fonctionnalités existent dans un rayon de 100 m (300 pi) d'un bâtiment?",
      "q04":"Inégale densité d'arbres et/ou shrubs.",
      "q05":"Treed les voies de guider les oiseaux vers façade.",
      "q06":"Flowered des jardins, des hautes herbes, des toits verts et/ou terraces.",
      "q07":"Water fonctionnalités offrant la possibilité pour le bain et la drinking.",
      "facade_type":"Façade Type:",
      "select_facade_type":"Select Type de Façade",
      "q08":"",
      "design_feature_options":[
         "Verre brise-vent, les refuges, son barrières, garde-corps",
         "Linkways, des lobbies, des alcôves, des solariums, des coins",
         "Haut de la page ouverte oreillettes et clos de cours",
         "Les murs de verre adjacentes à des lobbies, toiture végétalisée et terrasses",
         "Les fenêtres à la maison"
      ],
      "q09":[
         "Est caractéristique de la conception de moins de 10 m du bâtiment?",
         "N'lumière de remplissage de l'intérieur de l'espace?",
         "Est caractéristique de la conception de moins de 3 étages?",
         "N'verre uniformément couvrir 50% ou plus de la façade?",
         "Est-il une mangeoire pour les oiseaux(s) situé à plus de 1 m (3 pi) à partir de la fenêtre évalués?"
      ],
      "q10":[
         "Est caractéristique de la conception de plus de 5 mètres carrés dans la taille?",
         "Est caractéristique de la conception de plus de 5 mètres carrés dans la taille?",
         "Est-il de la végétation/eau caractéristiques qui se retrouvent à l'intérieur de l'enceinte?",
         "Est-il continu de verre étendues situées dans les 5 premiers étages?",
         "Est-il de la végétation face à la fenêtre évalués?"
      ],
      "properties_of_glass":"Propriétés de Glass:",
      "q11":"Can vous voyez un faible pour être distincte de la réflexion de la végétation et/ou le ciel dans différentes conditions d'éclairage de jour?",
      "q12":"Est la végétation visible à l'intérieur ou sur le côté opposé de la façade du bâtiment?",
      "visual_markers":"Marqueurs visuels:",
      "def_of_visual_marker":"* Un \"marqueur visuel' est le modèle de toute forme qui est appliqué sur ou est en face d'une fenêtre de la surface de la rencontre ci-dessous criteria.",
      "see_examples_of_visual_markers":"See Exemples de Marqueurs Visuels",
      "note_that_inverted":"REMARQUE: Répondez \" OUI \" pour les 4 questions suivantes si les moustiquaires sont définitivement fixés à l'extérieur de la surface de la façade en cours de assessed.",
      "q13":"Are il y a des repères visuels espacés de plus de 5 cm (2 pouces) à l'horizontale et/ou de 5 cm (2 pouces) à la verticale à part?",
      "q14":"Existe-il des repères visuels clairement visible dans différentes conditions d'éclairage de jour?",
      "q15":"Existe-il des repères visuels qui couvrent la majorité de la surface du verre jusqu'à 16 m (50 pi) au-dessus du sol?",
      "q16":"Existe-il un marqueur visuel situé à l'extérieur de la surface de verre?",
      "nighttime_factors":"La nuit Facteurs: ",
      "observe_factors_in_darkness":"Observer les facteurs suivants lors de l'obscurité",
      "nighttime_prompt":"Pour déterminer un bâtiment de nuit de collision menace de notation, de répondre à toutes les questions ci-dessous en sélectionnant \" OUI \" ou \"NON\".",
      "local_landscape_with_dist":"Paysage Local (<à 1,5 km du bâtiment):",
      "q17":"Ne bâtiments voisins réduire ciel et/ou de la visibilité de l'horizon?",
      "q18":"Est-il du littoral à moins de 1,5 km (1 mile) de la zone en cours d'évaluation?",
      "building_lighting":"Bâtiment Lighting:",
      "q23":"Is bâtiment de plus de 3 étages?",
      "q19":"C'est de la lumière à l'intérieur du bâtiment visible de l'extérieur?",
      "q20":"Sont des plantes d'intérieur (artificiel ou réel) visible de l'extérieur?",
      "q21":"Est extérieur lumière projetée sur le bâtiment?",
      "q22":"L'extérieur de la lumière dirigée vers le haut, dans le ciel de la nuit?",
      "save_responses_for":"ÉTAPE 4: Enregistrer toutes les réponses à",
      "save_responses":"Enregistrer les Réponses",
      "select_next_facade_for":"ÉTAPE 5: Sélectionnez le côté de la façade pour",
      "select_next_facade":"Sélectionnez Suivant Façade",
      "step6":"ÉTAPE 6: Générer un rapport pour",
      "view_reports":"Visualiser les Rapports",
      "current":"currrent",
      "current_building":"édifice actuel",
      "current_facade":"édifice actuel",
      "design_feature":"Caractéristique de Conception",
      "webcam":{
         "capture_photo":"Capture photo"
      }
   },
   "Report":{
      "header":"Générer des Rapports",
      "generate_report":"Générer le Rapport",
      "facade_threat_rating_scale":"Façade de la Menace de l'Échelle de Notation",
      "note":"* Un \"risque élevé\" à \"létales\" notation nécessite une action immédiate. Voir les liens ci-dessous pour les ressources sur la meilleure façon d'atténuer ce threat.",
      "low_risk":"Low Risque",
      "no_action_required":"Aucune action n'est requise",
      "moderate_risk":"Risque Modéré",
      "action_is_discretionary":"Action est discrétionnaire",
      "high_risk":"à Risque Élevé",
      "strongly_recommend_action":"recommandons Fortement de prendre des mesures",
      "lethal":"Létale",
      "mandatory_action":"Obligatoire de prendre des mesures en vertu de la réglementation",
      "canadian_law":"droit Canadien en vertu de la LEP et de l'EPA",
      "preview_report_for_different_building":"Aperçu de Rapports pour les Différents Building:",
      "building":"Building",
      "generate":{
         "report_header":"RABAT Application Rapport",
         "report_generated_for":"Les notations suivantes sont les résultats de RABAT du Canada BirdSafe Bâtiment de l'Évaluation des Risques pour: ",
         "facade_colon":"Façade: ",
         "algorithm":{
            "daytime_incomplete":"Façade de l'Évaluation Incomplète pour le Jour de Notation",
            "daytime_rating_is":"Diurne Cote: ",
            "nighttime_incomplete":"Façade de l'Évaluation Incomplète pour la Nuit de Notation",
            "nighttime_rating_is":"Nuit de Notation: "
         }
      }
   },
   "Links":{
      "header":"Liens utiles",
      "homes_safe_for_birds":"Foyers pour les Oiseaux",
      "workplaces_safe_for_birds":"le lieu de travail Sûr pour les Oiseaux",
      "global_mapper":"Global Oiseau Collision Mappeur",
      "collision_count_week":"Collision Compter de la Semaine",
      "birdsafe_consulting_serice":"BirdSafe® Service de Consultation de",
      "contact_flap_canada":"Contact RABAT Canada"
   },
   "About":{
      "header":"Sur RABAT Canada",
      "about_info":"RABAT Canada est un organisme de bienfaisance enregistré qui depuis plus de 25 ans, a été de protéger les espèces d'oiseaux lors de collisions avec des structures construites. Votre don nous aidera à continuer à développer la prévention des collisions avec des outils comme le RABAT App.",
      "visit_site":"VISIT flap.org",
      "give":"GIVE",
      "report_a_bug":"Report un Bug"
   },
   "copyright":"Cette application et sa méthodologie est la propriété exclusive de RABAT du Canada et ne peut être utilisé dans un but lucratif ou reproduit, en tout ou en partie, sans l'autorisation expresse du propriétaire. *BirdSafe est une marque déposée de la Fatale Lumière du Programme de Sensibilisation (RABAT) Canada.",
   "developers":"App développeurs: Andrew Friteuse et Michael Mesure",
   "errors":{

   }
}

export default locale;






// WEBPACK FOOTER //
// ./src/localization/FrenchFromAPI.js